export enum Context {
	Dashboard = "Dashboard",
	Extension = "Extension",
}
